module.exports = __webpack_public_path__ + "static/media/arrow-slide-izq.5364b644.svg";